import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';

export const useCopyToClipboard = () => {
  const dispatch = useDispatch();

  const copyToClipboard = (text: string) => {
    if (text.length === 0) return;

    navigator.clipboard.writeText(text);
    dispatch(showMessage({ message: 'Successfully copied', variant: 'success' }));
  };

  return copyToClipboard;
};
